export interface RestErrorMessage extends Error, RestErrorAdditionalParameters {}

/**
 * sync met service-contract CumLaudeError
 */
export interface RestErrorAdditionalParameters {
	error?: RestErrorMessageEnum;
	parameters?: {
		[key: string]: string;
	};
}

export enum RestErrorMessageEnum {
	/** Alleen frontend: het request is afgebroken (status 0), bijv. door wegnavigeren. Komt niet van de backend. */
	ABORTED = 'ABORTED',
	CREDENTIALS_ALREADY_EXIST = 'CREDENTIALS_ALREADY_EXIST',
	CREDENTIALS_ALREADY_EXIST_HERE = 'CREDENTIALS_ALREADY_EXIST_HERE',
	EMAIL_INVALID = 'EMAIL_INVALID',
	IMMUTABLE_ROLE = 'IMMUTABLE_ROLE',
	MEDEWERKER_NIET_IN_DIENST = 'MEDEWERKER_NIET_IN_DIENST',
	MISSING_MODULE = 'MISSING_MODULE',
	NO_ACCESS = 'NO_ACCESS',
	UNSUFFICIENT_LICENSES = 'UNSUFFICIENT_LICENSES',
	UNKNOWN = 'UNKNOWN',
}
